import Paper, { PaperProps, paperClasses } from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const StyledPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  [`&.${paperClasses.root}`]: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
}));
